import { latLngBounds } from 'leaflet';

const $inject = ['$q', 'itinerariesService', '$http', 'APP_CONFIG', 'moment'];

const bookingsService = function bookingsService($q, itinerariesService, $http, APP_CONFIG, moment) {
  let service = {};
  service.bookingsMasterCopy = [];
  service.bookings = [];
  service.clear = clear;
  service.add = add;
  service.getTotal = getTotal;
  service.getBooking = getBooking;
  service.getBookingPnr = getBookingPnr;
  service.getBookingPassenger = getBookingPassenger;
  service.getBookingHistory = getBookingHistory;
  service.getOfflineBooking = getOfflineBooking;
  service.aggregateItinerarySegments = aggregateItinerarySegments;

  function add(bookings) {
    const _bookings = [];
    const deDupe = bookings.filter(
      (booking) => !service.bookingsMasterCopy.find((masterBooking) => booking.Identifier === masterBooking.Identifier)
    );

    deDupe.forEach((booking) => {
      if (booking.Pnrs && booking.Pnrs.length > 0) {
        booking.Pnr = booking.Pnrs[0];
      }
      _bookings.push(booking);
    });

    Array.prototype.push.apply(service.bookings, _bookings);
    Array.prototype.push.apply(service.bookingsMasterCopy, _bookings);
  }

  function clear() {
    service.bookingsMasterCopy = [];
    service.bookings = [];
  }

  function getTotal() {
    return service.bookings.length;
  }

  function getBooking(itineraryId, passengerId, pcc) {
    let cachedBooking = _.find(
      service.bookings,
      (booking) => booking.ItineraryIdentifier === itineraryId && booking.Identifier === passengerId
    );
    if (cachedBooking) {
      return $q.resolve(cachedBooking);
    }
    return $q
      .all([itinerariesService.find(itineraryId, passengerId, pcc), getCurrentBooking(itineraryId, passengerId, pcc)])
      .then(([itinerary, currentBooking]) => {
        itinerary.currentBooking = currentBooking;
        return itinerary;
      });
  }
  function getBookingPnr(pnr, livePnrData) {
    return itinerariesService.findPnr(pnr, livePnrData).then(
      (booking) => {
        if (booking && booking.Passenger && booking.CurrentItinerary) {
          booking.Passenger.currentBooking = aggregateItinerarySegments(booking.CurrentItinerary);
        }

        return booking;
      },
      (error) => {
        return error;
      }
    );
  }
  function getBookingPassenger(passengerId, livePnrData) {
    return itinerariesService.findPassenger(passengerId, livePnrData).then(
      (booking) => {
        if (booking && booking.Passenger && booking.CurrentItinerary) {
          booking.Passenger.currentBooking = aggregateItinerarySegments(booking.CurrentItinerary);
        }

        return booking;
      },
      (error) => {
        return error;
      }
    );
  }
  function getCurrentBooking(itineraryId, passengerId, pcc) {
    return $http.get(`${APP_CONFIG.api.itinerary}${itineraryId}/current/${passengerId}/${pcc}`).then(
      ({ data: currentItineraries }) => aggregateItinerarySegments(currentItineraries),
      (error) => {
        if (error.status === 404) {
          return null;
        }
        throw error;
      }
    );
  }

  function getOfflineBooking(pnr, pcc) {
    return $q.all([itinerariesService.findOffline(pnr, pcc), getCurrentOfflineBooking(pnr, pcc)]).then(([itinerary, currentBooking]) => {
      itinerary.currentBooking = currentBooking;
      return itinerary;
    });
  }

  function getCurrentOfflineBooking(pnr, pcc) {
    return $http.get(`${APP_CONFIG.api.itinerary}current/${pnr}/${pcc}`).then(
      ({ data: currentItineraries }) => aggregateItinerarySegments(currentItineraries),
      (error) => {
        if (error.status === 404) {
          return null;
        }
        throw error;
      }
    );
  }

  //api/Itinerary/{itineraryId:guid}/passenger/{passengerId:guid}/history
  function getBookingHistory(itineraryId, passengerId) {
    let deferred = $q.defer();

    const apiUrl = `${APP_CONFIG.api.itinerary}${itineraryId}/passenger/${passengerId}/history`;
    $http.get(apiUrl).then((response) => deferred.resolve(response.data));

    return deferred.promise;
  }

  function aggregateItinerarySegments(currentItinerary) {
    return [].concat(
      (currentItinerary.Air || []).map(buildFlightViewModel),
      (currentItinerary.Cars || []).map(buildCarViewModel),
      (currentItinerary.Hotels || []).map(buildHotelViewModel),
      (currentItinerary.Rail || []).map(buildRailViewModel),
      (currentItinerary.GroundTransports || []).map(buildGroundViewModel)
    );
  }

  function buildFlightViewModel(airDataModel) {
    return angular.extend(
      {
        type: 'flight',
        dateOrder: moment(airDataModel.Start.DateLocal),
      },
      airDataModel
    );
  }

  function buildCarViewModel(carDataModel) {
    return angular.extend(
      {
        type: 'car',
        dateOrder: moment(carDataModel.Start.DateLocal),
      },
      carDataModel
    );
  }

  function buildHotelViewModel(hotelDataModel) {
    return angular.extend(
      {
        type: 'hotel',
        dateOrder: moment(hotelDataModel.Start.DateLocal).endOf('day'),
      },
      hotelDataModel
    );
  }

  function buildRailViewModel(railDataModel) {
    return angular.extend(
      {
        type: 'rail',
        dateOrder: moment(railDataModel.Start.DateLocal),
        transportation: railDataModel.Transportation,
      },
      railDataModel
    );
  }

  function buildGroundViewModel(groundDataModel) {
    return angular.extend(
      {
        type: 'ground',
        dateOrder: moment(groundDataModel.DateLocal),
      },
      groundDataModel
    );
  }

  function asTyped(leg, type) {
    leg.type = type;
    return leg;
  }

  return service;
};

bookingsService.$inject = $inject;

export default bookingsService;



// WEBPACK FOOTER //
// ./src/services/bookingsService.js